import styled from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme'
import Button from 'components/Button/index'
import { Input ,Col,Row, Select} from 'antd';
import { FONT } from 'theme/font'



export const SectionWrapper = styled(Flex)`
  width: 100%;
  border: 1px solid ${COLORS.PAGE_BORDER};
  box-shadow: 0px 2px 6px rgba(123, 97, 255, 0.15);
  margin: 30px 100px 20px 100px;
  border-radius: 10px;
  overflow: scroll;
  background: ${COLORS.WHITE};
  &::-webkit-scrollbar {
    display: none;
  }
  @media only screen and (max-device-width: 767px) {
    margin: 10px;
  }
  @media only screen and (min-width: 1200px) and (max-width: 1300px) {
    margin: 30px 20px 20px 20px;
  }
  @media only screen and (min-width: 768px )  and  (max-width : 1200px){
    margin: 10px;
  }
`
export const Outline = styled(Row)`
width:100%;
margin: 30px 100px 20px 100px;
@media only screen and (max-device-width: 767px) {
  margin: 10px;
}
@media only screen and (min-width: 768px )  and  (max-width : 1200px){
  margin: 10px;
}
`
export const Outline1 = styled(Row)`
width:100%;
border: 1px solid #E6E7EA;
border-radius:10px;
margin: 20px;
padding: 20px 40px;
background: ${COLORS.WHITE};
`
export const OfferColumn = styled(Col)`

border: 1px solid ${COLORS.PAGE_BORDER};
  box-shadow: 0px 2px 6px rgba(123, 97, 255, 0.15);
  background: ${COLORS.WHITE};
  border-radius: 5px;
  margin:10px;
  padding:15px;
`
export const TopHeader = styled(Flex)`
  padding: 20px 25px;
  position: relative;
  width: 100%;
  font-size: 2em;
`
export const TopHeading = styled(Flex)`
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  color: ${COLORS.GREY_P_100};
`

export const TopRightFlex = styled(Flex)`
  gap: 15px;
`
export const SmallButtons = styled(Button.Default)`
  background: ${COLORS.WHITE};
  padding: 9px;
  > div {
    margin-left: 0;
  }
`
export const CardRow = styled(Flex)`
  padding: 0 25px 25px 25px;
  gap: 20px;
`
export const SearchDiv = styled.div`
  padding: 10px 20px;
`
export const TabDiv = styled.div`
  padding: 0px 20px 20px 20px;
`



export const Name1 = styled.div`
  font-weight: 600;
  font-size: 16px;
  height: 21px;
  line-height: 20px;
  text-align: center;
  color: #1b1f22;
  text-transform: capitalize;
  @media only screen and (max-device-width: 767px) {
    font-size: 12px;
    line-height: 18px;
  }
  @media only screen and (min-width: 768px )  and  (max-width : 1200px){
    font-size: 12px;
    line-height: 18px;
  }
`

export const Name = styled.div`
font-style: normal;
font-weight: 500;
font-size: 14px;
line-height: 18px;
color: #343E59;

  
  @media only screen and (max-device-width: 767px) {
    font-size: 12px;
    line-height: 18px;
  }
  @media only screen and (min-width: 768px )  and  (max-width : 1200px){
    font-size: 12px;
    line-height: 18px;
  }
`

export const Address = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  color: #1b1f22;
  opacity: 0.48;
  @media only screen and (max-device-width: 767px) {
    font-size: 10px;
    line-height: 16px;
  }
  @media only screen and (min-width: 768px )  and  (max-width : 1200px){
    font-size: 10px;
    line-height: 16px;
  }
`

export const NameAdd = styled(Flex)`
  gap: 3px;
`
export const FullTable = styled.table`
  margin: 0;
  padding: 0;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 10px;
`
export const SlRow = styled.tr`
  padding: 10px;
  height: 103px;
  border-radius: 10px !important;
  border: 1px solid #e6e7ea !important;
  box-shadow: 0px 2px 8px 8px rgba(201, 201, 201, 0.1),
    inset 0px -1px 0px rgba(0, 0, 0, 0.05);
`

export const SlCol = styled.td`
  td {
    border: 1px solid #e6e7ea;
    border-style: solid none;
    padding: 10px;
  }
`
export const SlCol1 = styled.td`
  padding-left: 15px;
`
export const ContentCenterDiv = styled.div`
  text-align: center;
`
export const LeftAlignCol = styled(Col)`
padding-left: 10px;
`
export const SearchInput = styled(Input)`
::placeholder {
  font-size: 16px;
}
width: ${props => (props.width ? props.width : '250px')} !important;
height: ${props => (props.height ? props.height : '40px')};
border-radius: 8px;
box-shadow: none;
border-color: ${props => (props.error ? 'red' : '#e9e9e9')};
:focus {
  border-color: #e9e9e9;
  box-shadow: none;
}
:hover {
  border-color: #e9e9e9;
}
:not(.ant-input-affix-wrapper-disabled):hover {
  border-color: #e9e9e9 !important;
}
.ant-input-affix-wrapper-focused {
  box-shadow: none;
  border-right-width: 0px !important;
}
`

export const SpinWrapper = styled(Flex)`
  padding-top: 25px;
`
export const UploadMsgFlex = styled(Flex)`
  height: 100%;
`
export const ResultDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_BASE};
  line-height: 21px;
  text-align: center;
  color: ${COLORS.GREY_T_20};
  margin: 5px 0;
`
export const FileInfoDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_BASE};
  line-height: 21px;
  text-align: center;
  color: ${COLORS.GREY_T_60};
  width: 70%;
`
export const FileTextSpan = styled.span`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_BASE};
  line-height: 21px;
  color: ${COLORS.GREY_T_60};
`
export const ResultIconDiv = styled.div`
  text-align: center;
  margin-bottom: 10px;
`
export const ButtonDiv = styled.div`
  margin: 10px 0;
`
export const StyledSelect = styled(Select)`
width: 100% !important;
height: 48px !important;
font-style: normal;
font-weight: 500;
font-size: 16px;
line-height: 24px;
color: #010e30;
.ant-select-selector {
  
  background-color: #fafafb !important;
  height: 48px !important;
  border-radius: 8px !important;
  border-color: #e9e9e9 !important;
  box-shadow: none !important;
}
.ant-select-selection-item {
  background-color: ${props =>
    !props.disabled
      ? props?.mode === 'multiple' || props?.mode === 'tags'
        ? '#ebecee'
        : '#ffffff'
      : '#f5f5f5'};
  border-radius: 6px;
  color: ${props => !props.disabled && '#010e30'};
}
.ant-select-multiple.ant-select-lg .ant-select-selection-item {
  background-color: ${props =>
    !props.disabled
      ? props?.mode === 'multiple' || props?.mode === 'tags'
        ? '#ebecee'
        : '#ffffff'
      : '#f5f5f5'};
}
:hover {
  border-radius: 6px;
  color: #010e30;
}
.ant-select-dropdown-placement-bottomLeft {
  width: 1000px !important;
}
.ant-select-selection-item-remove {
  display: flex;
  align-items: center;
}
.ant-select-selection-placeholder {
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
}
`

export const DesHeading = styled.div`
font-size: 20px;
font-weight: 700;
line-height: 28px;
text-align: left;
color: #343E59;
`

export const DesHeading1 = styled.div`
font-size: 16px;
font-weight: 600;
line-height: 21px;
color: #010E30;
text-transform: capitalize;
`